export const SERVICES = [
  { id: "google-ads", title: "Google Ads" },
  { id: "meta-ads", title: "Meta Ads" },
  { id: "social-media", title: "Social Media Marketing & Management" },
  { id: "crm", title: "CRM" },
  { id: "ai-automations", title: "AI Automations" },
  { id: "web-dev", title: "Web Dev/Design" },
  { id: "video-editing", title: "Video Editing" },
  { id: "graphic-design", title: "Graphic Designing" },
];

export const WORKS = [
  {
    title: "Hellas Yachting",
    desc: "A luxury yacht charter website for Greece.",
    tag: "Case Study · Web Design & Development",
    url: "https://yacht-design-hub--fahadwebdesigne.replit.app/",
    image:
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_digital-growth-hub-314/artifacts/2ee1856a8152deaf_download.png",
  },
  {
    title: "Dream Yacht Showcase",
    desc: "A yacht-showcase landing page concept.",
    tag: "Landing Page Concept",
    url: "https://yacht-craft-studio.lovable.app/",
    image:
      "https://images.unsplash.com/photo-1605281317010-fe5ffe798166?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "Ironside Garage Doors",
    desc: "A garage-door website focused on craft, service and a welcoming first impression.",
    tag: "Case Study · Home Services Website",
    url: "https://preview--door-beauty-showcase.lovable.app/?__lovable_sha=0dba14a0",
    image:
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_digital-growth-hub-314/artifacts/4aa09214a9e13517_download%20%281%29.png",
  },
  {
    title: "Yacht Dreams · Sanlorenzo SL88",
    desc: "A cinematic landing page for an Italian yacht showcase.",
    tag: "Case Study · Yacht Landing Page",
    url: "https://dream-yacht-showcase.lovable.app/",
    image:
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_digital-growth-hub-314/artifacts/1865134c55882e3b_download%20%282%29.png",
  },
];

export const ABOUT_POINTS = [
  { num: "01", text: "Start with the real challenge" },
  { num: "02", text: "Make the plan make sense" },
  { num: "03", text: "Build with care" },
  { num: "04", text: "Learn and keep moving" },
];

export const PROCESS_STEPS = [
  {
    num: "01",
    word: "Listen",
    title: "Get oriented",
    desc: "We learn about your business, your audience and the point you want to reach.",
  },
  {
    num: "02",
    word: "Focus",
    title: "Choose the work",
    desc: "Together, we find the clearest priorities and shape a practical direction.",
  },
  {
    num: "03",
    word: "Make",
    title: "Put it in motion",
    desc: "We build, launch and manage the agreed work with care and attention.",
  },
  {
    num: "04",
    word: "Learn",
    title: "Refine the next step",
    desc: "We review what the work is telling us and use it to make better decisions.",
  },
];

export const FAQS = [
  {
    q: "How is your pricing structured?",
    a: "Two simple ways. Monthly retainers for ongoing growth — ads, social media and automation — and fixed-scope pricing for one-off builds like websites and brand identities. Either way, you approve the full cost before we start. No surprise invoices.",
  },
  {
    q: "How long does a typical project take?",
    a: "A landing page usually ships in two to three weeks, a full website in four to six. Ad campaigns go live within the first week, with meaningful performance data after about thirty days. We agree the timeline with you before any work begins.",
  },
  {
    q: "What does working together actually look like?",
    a: "We listen first: your business, your audience, your goals. Then we agree the priorities, put the work in motion, and review what the numbers tell us. You get one connected team and clear updates at every step.",
  },
  {
    q: "Do I need all eight services?",
    a: "No. Most clients start with one or two — often ads plus a landing page — and add more as results compound. We only recommend what your current stage of growth genuinely needs.",
  },
  {
    q: "How do you measure success?",
    a: "Against the numbers that matter to you: cost per lead, return on ad spend, conversion rate, and revenue influenced. Everything is tracked from day one and reported in plain language — no vanity metrics.",
  },
  {
    q: "Do you work with businesses outside your city?",
    a: "Yes. Elevora works with clients worldwide, fully remotely. Strategy calls, reporting and day-to-day support all happen online, on your timezone.",
  },
];

export const SNAPSHOT = [
  { label: "Connected digital services", value: "08" },
  { label: "Website and landing-page projects", value: "04" },
  { label: "Steps in our working approach", value: "04" },
];
